import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=1d9228f2&scoped=true"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"
import style0 from "./Page2.vue?vue&type=style&index=0&id=1d9228f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9228f2",
  null
  
)

export default component.exports